module.exports = __webpack_public_path__ + "static/img/yingrenClick.d735ab8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mImage/yingrenClick.png
// module id = gkbU
// module chunks = 0